import { createSelector } from 'reselect';
import { AppState } from '@/store';

export const getStatsState = (state: AppState) => state.stats;

export const getStatsData = createSelector(getStatsState, stats => stats.data);
